import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors.ts';

const FooterContainer = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: transparent;
    padding: 2rem 0;
    margin-top: auto;
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 2rem;

  p {
    color: ${colors.neutral[400]};
    font-size: 0.6rem;
  }
`;

const Footer = () => {
    return (
        <FooterContainer>
            <FooterBottom>
                <p>&copy; {new Date().getFullYear()} Caraloco. All rights reserved.</p>
            </FooterBottom>
        </FooterContainer>
    );
};

export default Footer;